export enum BadgeStatus {
  Success = 'success',
  Error = 'error',
  Info = 'info',
}
